module.exports = __webpack_public_path__ + "static/media/zoom-out3.c19e68f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/zoom-out3.svg
// module id = 3848
// module chunks = 7